import React, {Fragment, useEffect} from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";

import {featureInterface} from "../../../../../interfaces/featureInterface";
import LookFeatureImage from "./lookFeatureImage";
import FeatureName from "../../../../visComponents/featureName";
import LookFeatureOptions from "./lookFeatureOptions";
import {setLookActiveCategory, setLookOverlayOpened} from "../../../../../actions/lookFunctions";
import MaterialSpinner from "../../../../ui/materialSpinner";
import {updateCanvasCount} from "../../../../../actions/actionFunctions";
import LookFeatureMatchingStyleAlert from "./lookFeatureMatchingStyleAlert";
// import LookFeatureMobileButtons from "./lookFeatureMobileButtons";
import LookFeatureRemoveButton from "../lookFeatureRemoveButton";
import GroheMobileFeatureTop from "../../../grohe/groheMobile/groheMobileFeature/groheMobileFeatureTop";
import LookFeatureColorMatch from "./lookFeatureColorMatch";
import GroheFeatureOptions from "../../../grohe/groheNavigation/groheFeature/groheFeatureOptions";
import {getFeatureIsLocked} from "../../../../../misc/helpers";
import GroheFeatureLockedBadge from "../../../grohe/groheNavigation/groheFeature/groheFeatureLockedBadge";
import LookFeatureRevertButton from "./lookFeatureRevertButton";
// import LookFeatureAddToCartButton from "./lookFeatureAddToCartButton";
// import GroheFeatureQuantity from "../../../grohe/groheNavigation/groheFeature/groheFeatureQuantity";
// import LookFeatureChangeButton from "./lookFeatureChangeButton";
import store from "../../../../../store";
import {usePrevious} from "../../../../../misc/helperHooks";
// import LookFeatureCallForPricingButton from "./lookFeatureCallForPricingButton";
import LookFeatureUnlockButton from "./lookFeatureUnlockButton";
import GroheFeatureTopButtons from "../../../grohe/groheNavigation/groheFeature/groheFeatureTopButtons";
import {useViewItemAnalyticsEvent} from "../../../hocs/analyticsEventHooks";
import LookFeatureNotInStock from "./lookFeatureNotInStock";
import LookFeatureSku from "./lookFeatureSku";
import {IS_LIXIL_SERVERS} from "../../../../../config";
import FeatureInfoBrand from "../../../../selectionWindow/selectionFeatureInfo/featureInfoBrand";
import GroheFeatureMoreInfoButton from "../../../grohe/groheNavigation/groheFeature/groheFeatureMoreInfoButton";
import LookFeaturePairPrice from "../lookListFeature/lookFeaturePairPrice";


const LookFeature = (props) => {

  const {lookActiveFeature, lookActiveCategory, isMobile, fabricatorData, leadCaptureClickCount,
    wizardActiveItem} = props;
  const fabricatorSettings = fabricatorData.settings;

  const featureIsLocked = getFeatureIsLocked(lookActiveFeature);
  const prevActiveFeature = usePrevious(lookActiveFeature);

  useEffect(() => {
    if (!prevActiveFeature && lookActiveFeature && featureIsLocked && (!fabricatorSettings.clickLeadCapture || ((leadCaptureClickCount + 1) >= fabricatorSettings.clickLeadCount))) {
      window.clearTimeout(window.lookLeadCaptureId);
      window.lookLeadCaptureId = setTimeout(() => {
        const {lookState} = store.getState();
        if (lookState.lookActiveFeature) {
          // show locked overlay here
          // setLookOverlayOpened(LOOK_OVERLAYS.leadCapture);
        }
      }, 3000)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [lookActiveFeature]);

  useViewItemAnalyticsEvent(lookActiveFeature, wizardActiveItem, fabricatorSettings);

  if (!lookActiveFeature) {
    if (lookActiveCategory) {
      return <MaterialSpinner/>
    }
    return null
  }

  return (
    <div className={"lk-feature" + (featureIsLocked ? " lk-feature--locked" : "")}>
      {isMobile ? null : <LookFeatureRevertButton/>}
      <div className="lk-feature__main">
        {isMobile ? null : <LookFeatureImage featureIsLocked={featureIsLocked}/>}
        {isMobile ? null : <FeatureInfoBrand feature={lookActiveFeature}/>}
        <GroheFeatureTopButtons/>
        {isMobile
          ? <GroheMobileFeatureTop/>
          : featureIsLocked ? <GroheFeatureLockedBadge/> : (
            <Fragment>
              <div className="lk-title">
                <h2 className="lk-title__text bold">
                  <FeatureName feature={lookActiveFeature} useCollectionName={true}/>
                </h2>
                {isMobile ? (
                  <LookFeatureRemoveButton lookFeature={lookActiveFeature} isIcon={true}/>
                ) : (
                  <LookFeatureMatchingStyleAlert lookFeature={lookActiveFeature}/>
                )}
              </div>
              <p className="lm-feature__content-model">
                <LookFeatureSku lookFeature={lookActiveFeature}/>
                <LookFeatureNotInStock lookFeature={lookActiveFeature}/>
              </p>
            </Fragment>
          )}
        {featureIsLocked || !IS_LIXIL_SERVERS ? null : (
          <p className="lm-feature__content-description">
            <FeatureName feature={lookActiveFeature}/>
          </p>
        )}
        <div className={"lk-feature__price" + (fabricatorSettings.callForPricing ? " lk-feature__price--with-call" : "")}>
          {featureIsLocked ? null : (
            <div className="lk-title lk-price">
              <LookFeaturePairPrice lookFeature={lookActiveFeature}/>
              {/*{fabricatorSettings.callForPricing ? <LookFeatureCallForPricingButton/> : null}*/}
            </div>
          )}
          <GroheFeatureMoreInfoButton />
        </div>
        {featureIsLocked ? <LookFeatureUnlockButton/> : null}
        <div className="lk-feature__opt">
          <GroheFeatureOptions/>
          <LookFeatureOptions/>
        </div>
        {document.kvConfig.visualizerType === "bvLook" && !fabricatorData.isEncore ? <LookFeatureColorMatch/> : null}
      </div>
      {/*<GroheFeatureQuantity />*/}
      {/*<div className={"lk-feature__buttons" + (isMobile ? " lk-button" : "")}>*/}
      {/*  /!*<LookFeatureAddToCartButton/>*!/*/}
      {/*  <LookFeatureChangeButton/>*/}
      {/*  {isMobile ? (*/}
      {/*    <LookFeatureMobileButtons moreInfoClick={moreInfoClick} threeDButtonClick={threeDButtonClick} />*/}
      {/*  ) : null}*/}
      {/*</div>*/}
      <div className="lk-feature__buttons">
        <LookFeatureRemoveButton lookFeature={lookActiveFeature}/>
      </div>
    </div>
  )
};

LookFeature.propTypes = {
  lookFeature: PropTypes.shape(featureInterface),
}

const mapStateToProps = (store) => {
  const {lookActiveFeature, lookActiveCategory} = store.lookState;
  const {isMobile} = store.serverState;
  const {isPhoneNumberValidated, leadCaptureClickCount} = store.userState; // to update component when user is logged in
  const {wizardActiveItem} = store.wizardState;

  return {
    lookActiveFeature,
    lookActiveCategory,
    isMobile,
    isPhoneNumberValidated,
    leadCaptureClickCount,
    fabricatorData: store.fabricatorState,
    wizardActiveItem,
  };
};

const mapDispatchToProps = {
  setLookActiveCategory,
  updateCanvasCount,
  setLookOverlayOpened,
};

export default connect(mapStateToProps, mapDispatchToProps)(LookFeature)
